export default __webpack_public_path__ + "static/media/right-arrow-solid.a4518066.svg";